// <s-load-more>: appends the next page of a paginated product grid when the shopper scrolls near
// its end (or taps the "Load more" link), until there are no pages left.
class SLoadMore extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-load-more-grid]');
    this.button = this.querySelector('[data-load-more-button]');
    this.footer = this.querySelector('[data-load-more-footer]');
    this.status = this.querySelector('[data-load-more-status]');
    this.nextUrl = this.dataset.nextUrl || '';
    this.loading = false;
    if (!this.grid || !this.button || !this.nextUrl) return;

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.loadNext();
    });

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
    }, { rootMargin: '600px 0px' });
    this.observer.observe(this.footer);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadNext() {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(this.nextUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.getElementById(this.grid.id);
      const nextHost = nextGrid?.closest('s-load-more');
      const items = nextGrid ? Array.from(nextGrid.children) : [];
      this.grid.append(...items.map((item) => document.importNode(item, true)));
      this.nextUrl = nextHost?.dataset.nextUrl || '';
      if (this.status) this.status.textContent = this.nextUrl ? this.status.dataset.loadedLabel : this.status.dataset.endLabel;
      if (this.nextUrl) {
        this.button.href = this.nextUrl;
      } else {
        this.observer?.disconnect();
        this.button.remove();
      }
    } catch (error) {
      // Leave the link in place so a tap falls back to a normal page load.
      this.observer?.disconnect();
    } finally {
      this.loading = false;
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('s-load-more')) customElements.define('s-load-more', SLoadMore);
